/* global _ */
import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import adaptive from './adaptive'; // change to player in the future
import player from './player';
import interactions from './interactions';
import helpers from './helpers';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // PLAYER
    orientation: null,
  },
  mutations: { // used to change the value of a state
    // bulbControls (referenced in player_v1 -- can we remove?)
    setOrientation: (state, orientation) => {
      state.orientation = orientation;
    },
  },
  modules: {
    adaptive, // a lot in here we don't use.
    player,
    interactions,
    helpers
  },
});

export default store;
